import classNames from 'classnames'
import searchFilters from 'map/filters'
import Checkbox from '@components/Checkbox'
import Button from '@components/Button'
import styles from './styles.module.scss'

const Filters = ({ filters = {}, onFilter, toggleResultsView }) => (
    <>
        <div className={styles.filters}>
            {searchFilters.map((filter, i) => (
                <div className={classNames('row', 'no-gutters', styles.filterGroup)} key={i}>
                    <div className={styles.filterTitle}>
                        <T>{filter.name}</T>
                    </div>
                    {filter.options.map(({ label, value }, index) => (
                        <div className="col-6" key={index}>
                            <Checkbox
                                checked={filters[value] || false}
                                onChange={() => onFilter({ label, value })}
                                className="mb-3">
                                <T>{label}</T>
                            </Checkbox>
                        </div>
                    ))}
                </div>
            ))}
        </div>
        <div className={styles.filtersClose}>
            <Button onClick={toggleResultsView} size="small" btnStyle="outline">
                <T>map.filter.close.filters</T>
            </Button>
        </div>
    </>
)

export default Filters
